import { SharedAccountGame } from '@/models/configuration/SharedAccount.types'

/**
 * A game is "banned" only when banned_until is set AND still in the future.
 * A populated past date means the ban has lapsed -> treat as available.
 */
export function isGameBanned(
  bannedUntil: string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!bannedUntil) return false
  const until = new Date(bannedUntil)
  if (isNaN(until.getTime())) return false
  return until.getTime() > now.getTime()
}

export function isGameActivelyBanned(
  game: SharedAccountGame,
  now: Date = new Date(),
): boolean {
  return isGameBanned(game.banned_until, now)
}

export interface BorrowStatus {
  borrowed: boolean
  /** PC hostname when the borrowing session is live on a PC in this arena. */
  pcName: string
  /** Borrowed, not resolvable to a local PC, and tied to a different arena. */
  otherArena: boolean
}

/**
 * Resolve how an account's "in use" state should be shown.
 * PC name wins (most useful); we don't gate on borrowed_in_arena_id because the
 * API often leaves it null even when an account is borrowed.
 */
export function getBorrowStatus(
  account: {
    borrowed_by_session_id: string | null
    borrowed_in_arena_id: number | null
  },
  sessionHostnames: Record<string, string> = {},
  currentArenaId: number | string | null = null,
): BorrowStatus {
  if (!account.borrowed_by_session_id) {
    return { borrowed: false, pcName: '', otherArena: false }
  }
  const pcName = sessionHostnames[String(account.borrowed_by_session_id)] || ''
  const otherArena =
    !pcName &&
    account.borrowed_in_arena_id != null &&
    currentArenaId != null &&
    Number(account.borrowed_in_arena_id) !== Number(currentArenaId)
  return { borrowed: true, pcName, otherArena }
}
